import { useCallback, useState } from 'react';
import cn from 'classnames';
import Flex from '@creditflowresearch/uilib/Flex';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import styles from './BondScreenerSearchInput.module.scss';

const MIN_SEARCH_LENGTH = 2;

interface IBondScreenerSearchInputProps {
  onSearch: (value: string) => void,
  className?: string,
  dataTest?: string,
  placeholder?: string,
  disabled?: boolean,
  initialSearchValue?: string,
}

const sanitize = (value: string) => value.replace(/\s{2,}/g, ' ').trimStart();

const BondScreenerSearchInput = ({
  onSearch,
  className,
  dataTest,
  placeholder = 'Search',
  disabled = false,
  initialSearchValue = '',
}: IBondScreenerSearchInputProps) => {
  const [value, setValue] = useState(() => initialSearchValue);
  const [error, setError] = useState<string | null>(null);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
    const next = sanitize(event?.target?.value ?? '');
    setValue(next);

    // Trim trailing space for validation and API — user may still be typing
    const trimmedValue = next.trimEnd();

    if (trimmedValue.length > 0 && trimmedValue.length < MIN_SEARCH_LENGTH) {
      setError(`Search must contain at least ${ MIN_SEARCH_LENGTH } characters`);
      return;
    }

    setError(null);
    onSearch(trimmedValue);
  }, [onSearch]);

  return (
    <Flex flex={ { sm: '1', xl: 'none' } } direction="column" className={ cn(className) }>
      <SearchInput
        name="searchCorporateBondScreener"
        placeholder={ placeholder }
        value={ value }
        formFieldClassName={ spacesStyles.mbn }
        dataTest={ dataTest }
        onChange={ handleChange }
        disabled={ disabled }
      />
      { error && (
        <span className={ styles.error } data-test={ `${ dataTest }Error` }>{ error }</span>
      ) }
    </Flex>
  );
};

export default BondScreenerSearchInput;
